import React, { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import { withRouter } from "react-router-dom";
import { Button } from "aible";
import moment from "moment";
import IconAgentCustom from "images/agent_custom_icon.png";
import IconAgentAible from "images/agent_aible.svg";
import IconAgentTop from "images/agent_top.svg";
import AlwaysOnIcon from "images/Optimize-Agent-Icon.svg";
import AiqIcon from "images/Agent Icons/AIQ_Agents/nvidia-ai-icon.png";
import Tooltip from "components/Inputs/Tooltip";
import * as aibleAnywhereReducer from "containers/AibleAnywhere/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as viewReducer from "containers/View/reducer";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";
import styles from "./style.module.css";
import SearchInput from "components/Inputs/SearchInput/SearchInput";
import AgentPinButton from "components/AibleAgent/AgentPinButton";
const AgentViewContainer = ({ history }) => {
    const [searchInput, setSearchInput] = useState("");
    const aaProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    const retProjects = Object.keys(aaProjects)
        .filter((a) => a !== "misc")
        .filter((a) => a !== "generate_agent")
        .map((a) => ({ id: a, ...aaProjects[a] }));
    const filterProjects = Object.keys(retProjects)
        .filter((a) => searchInput === "" || (retProjects[a]?.name ?? "").toLowerCase().indexOf(searchInput) !== -1)
        .map((a) => ({ id: a, ...retProjects[a] }));
    return (React.createElement("div", { className: styles.agentViewContainer },
        React.createElement("div", { className: styles.paneHolder },
            React.createElement("div", { className: styles.leftPane },
                React.createElement("div", { className: styles.leftWelcome },
                    React.createElement("img", { src: IconAgentAible, style: { height: "64px", width: "64px", marginBottom: "20px" } }),
                    React.createElement("div", null, "How can I help you today?")),
                React.createElement(ChatPane, null),
                React.createElement("div", { className: styles.topAgentsHolder },
                    React.createElement("div", { className: styles.topAgents },
                        React.createElement("div", { className: styles.agentFlex },
                            React.createElement("img", { src: IconAgentTop, style: { height: "16px", width: "16px", marginRight: "5px" } }),
                            "Top " + retProjects.filter((a, i) => i < 3).length + " Agents"),
                        React.createElement("div", { className: styles.topAgentsBox }, retProjects
                            .filter((a, i) => i < 3)
                            .map((a) => (React.createElement("div", { className: styles.topAgent, onClick: () => history.push("agent/" + a?.id) },
                            React.createElement("img", { src: a?.isAibleAgent ? IconAgentAible : IconAgentCustom, style: { height: "24px", width: "24px", marginBottom: "5px" } }),
                            React.createElement("div", { className: styles.topAgentLabel, title: a?.name }, a?.name)))))))),
            React.createElement("div", { className: styles.rightPane },
                React.createElement("div", { className: styles.rightHeader }, "Aible Agents"),
                React.createElement("div", { className: styles.rightActions },
                    React.createElement(Button, { className: styles.rightButton },
                        React.createElement("div", { className: styles.buttonTop }, "My Agents"),
                        React.createElement("div", { className: styles.buttonBot }, (filterProjects !== undefined ? Object.keys(filterProjects).length : 0) + " Available")),
                    React.createElement(Button, { className: styles.rightButton, onClick: () => history.push("agent") },
                        React.createElement("div", { className: styles.buttonTop }, "Create a New Agent"),
                        React.createElement("div", { className: styles.buttonBot }, "No Code Required!")),
                    React.createElement(Button, { className: styles.rightButton },
                        React.createElement("div", { className: styles.buttonTop }, "Agent Marketplace"),
                        React.createElement("div", { className: styles.buttonBot }, "Discover Top Agents")),
                    React.createElement(Button, { className: styles.rightButton },
                        React.createElement("div", { className: styles.buttonTop }, "Import Agent"),
                        React.createElement("div", { className: styles.buttonBot }, "Import from JSON"))),
                React.createElement("div", { className: styles.rightSearch },
                    React.createElement(SearchInput, { placeholder: "Search Available Agents", value: searchInput, onChange: (val) => setSearchInput(val) })),
                React.createElement("div", { className: styles.agentTable }, filterProjects !== undefined &&
                    Object.keys(filterProjects).map((a) => (React.createElement(AibleAgentTile, { agent: filterProjects[a], history: history }))))))));
};
export const AibleAgentTile = ({ agent, history, showPinButton }) => {
    const dispatch = useDispatch();
    const isAibleSafeClawAgent = agent?.isAgentC === true;
    const isAiqAgent = agent?.aiqType !== undefined;
    const isOpenShellOrigin = agent?.workflowOrigin === "OPENSHELL";
    const isAiqOrigin = agent?.workflowOrigin === "AIQ";
    const handleOpen = () => {
        if (isAibleSafeClawAgent) {
            dispatch(viewReducer.initOpenAibleClawAgent(agent?.id));
        }
        else if (isAiqAgent) {
            dispatch(viewReducer.initOpenAiqAgent(agent?.id));
        }
        else if (agent?.runToggle === "BACKEND" && agent?.executionId !== undefined) {
            history.push("agent/" + agent?.id + "/new");
            dispatch(viewReducer.updateAgentAutonomyView("LOW"));
            // dispatch(viewReducer.updateAgentAutonomyView("LOW"));
            // dispatch(chatGPTReducer.initNewChat(true)).then(() => {
            //   dispatch(chatGPTReducer.updateBackendExecutionId(agent?.executionId));
            //   dispatch(chatGPTReducer.updateAgentId(agent?.id));
            // });
        }
        else {
            dispatch(chatGPTReducer.handleAibleAnywhereSteps(agent, undefined, undefined, true));
        }
    };
    const getAibleAgentIcon = () => {
        if (isAibleSafeClawAgent) {
            return AlwaysOnIcon;
        }
        if (isAiqAgent) {
            return AiqIcon;
        }
        if (agent?.isAibleAgent) {
            return IconAgentAible;
        }
        return IconAgentCustom;
    };
    const handlePublishAgent = (id) => {
        const createOptions = {
            id: id,
            saveToMyWork: false,
            forceToastMessage: "Published to Agent Templates"
        };
        // console.log("Publishing agent: ", id, createOptions);
        dispatch(blueprintReducer.createBlueprintFromBlueprintId(createOptions));
    };
    return (React.createElement("div", { className: styles.agentTile, onClick: () => {
            handleOpen();
        } },
        showPinButton && React.createElement(AgentPinButton, { agentId: agent?.id }),
        React.createElement("div", { className: styles.agentTileActions },
            React.createElement(Button, { onClick: (e) => {
                    e.stopPropagation();
                    handlePublishAgent(agent?.id);
                }, style: { marginRight: "10px" }, isSmall: true }, "Publish"),
            React.createElement(Button, { style: { padding: "5px", marginRight: "10px" }, onClick: async (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleOpen();
                } }, "Open"),
            !isAibleSafeClawAgent &&
                !(agent?.runToggle === "BACKEND" && agent?.executionId !== undefined) &&
                !isAiqAgent && (React.createElement(Button, { style: { padding: "5px", marginRight: "10px" }, onClick: async (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    history.push("agent/" + agent?.id + "/new");
                    dispatch(viewReducer.updateAgentAutonomyView("LOW"));
                } }, "Edit")),
            React.createElement(Button, { style: { padding: "5px", marginRight: "10px" }, onClick: async (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    await dispatch(blueprintReducer.handleDelete(agent?.id));
                    // Hacky for now just repull all blueprints
                    dispatch(aibleAnywhereReducer.fetchAA(true));
                } }, "Delete")),
        React.createElement("img", { src: getAibleAgentIcon(), style: { height: "56px", width: "56px", borderRadius: "4px" } }),
        React.createElement("div", { className: styles.agentTileInner },
            React.createElement("div", { className: styles.agentTileNameWrapper },
                React.createElement("div", { className: styles.agentTileName }, agent?.name),
                agent?.created_date !== undefined && (React.createElement("div", { className: styles.templateItemUpdatedDate }, moment.utc(agent?.created_date).local().fromNow()))),
            React.createElement("div", { className: styles.agentDescription }, agent?.description ?? agent?.defaultPrompt ?? agent?.prompt))));
};
const ChatPane = ({}) => {
    const dispatch = useDispatch();
    const [userPrompt, setUserPrompt] = useState("");
    return (React.createElement("div", { className: styles.newChatActionsWrapper, style: { bottom: "200px" } },
        React.createElement("div", { className: styles.newChatActions, style: {
                boxShadow: `0px 0px 7px rgb(133, 86, 235)`,
                border: `1px solid rgb(133, 86, 235)`
            }, id: "chat-message-box" },
            React.createElement("textarea", { className: styles.chatPrompt, onChange: (val) => setUserPrompt(val.currentTarget.value), placeholder: "What would you like to build?", autoFocus: true }),
            React.createElement("div", { className: styles.botActions },
                React.createElement(Tooltip, { trigger: userPrompt === undefined || userPrompt === "" ? ["none"] : ["hover"], overlay: "Use the LLM to generate a new Aible Agent from this prompt" },
                    React.createElement(Button, { style: {
                            marginRight: "10px",
                            fontSize: "13px"
                        }, onClick: () => {
                            dispatch(aibleAnywhereReducer.generateAAFull(userPrompt));
                        }, disabled: userPrompt === undefined || userPrompt === "" }, "Create New Agent"))))));
};
export default withRouter(AgentViewContainer);
